<template>
  <div>
    <link
      href="https://fonts.googleapis.com/css2?family=Turret+Road:wght@500;700&display=swap"
      rel="stylesheet"
    />
    <div class="container">
      <div class="wrapper">
        <div class="flexbox">
          <div class="title" >Game Theory</div>
          <img src="../assets/theory1.gif" alt="" />
        </div>

        <div class="grid-box">
          <div class="box" data-aos="fade-right" data-aos-duration="1750" data-aos-ease-in="ease-in">
            <div class="box-title">Mechanics</div>
            <div class="box-content">
              <ul>
                <li>
                  The game can be switched <span class="bold">on</span> and
                  <span class="bold">off</span> by the game master (i.e. me) or
                  anyone who holds at least 5% of the total supply
                </li>
                <li>
                  The game switch has a 12-hour cooldown period (once it’s on,
                  it cannot be switched off in 12 hours, and vice versa)
                </li>
                <li>
                  We can adjust this if necessary later to keep things fun for
                  all
                </li>
              </ul>
            </div>
          </div>

          <div class="box" data-aos="fade-right" data-aos-duration="1000">
            <div class="box-title">
              <span>Game</span>
              <span class="pound"> #</span>
              <span>ON</span>
            </div>

            <div class="box-content">
              <ul>
                <li>
                  For each $HODL token transfer, 1% of the transfer amount will
                  be taxed and redistributed pro-rata to $HODL holders
                </li>
                <li>
                  This means strong hands who hodl will see their balance
                  increasing while weak hands selling and new hands buying the
                  tokens
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="box1" data-aos="fade" data-aos-duration="1000">
          <span class="hint">
            *there are several other strategies you can exploit, but what fun
            would it be if we told you everything you could do?
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.container {
  background: black;
  padding: 4em 0;
}

.wrapper {
  padding: 2em 4em;
  font-family: "Turret Road", cursive;
  display: grid;
  justify-content: center;

  .flexbox {
    display: flex;
    align-items: center;
    margin-bottom: 1em;
    gap: 1em;

    img {
      width: 100px;
    }
  }
}

.title {
  font-size: 300%;
  color: white;
}

.grid-box {
  display: grid;
  grid-gap: 2em;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  margin-bottom: 2em;
}

.box {
  background: white;
  padding: 2em;
  border-radius: 5px;

  .box-title {
    font-size: 200%;
    margin-bottom: 0.5em;
  }

  .pound {
    font-family: "Times New Roman", Times, serif;
    font-weight: bold;
  }

  .box-content {
    ul {
      display: grid;
      grid-gap: 1em;

      li {
        .bold {
          font-weight: bold;
        }
      }
    }
  }
}

.hint {
  color: rgb(150, 150, 150);
}

@media (max-width: 650px) {
  .grid-box {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}
  .wrapper {

    .flexbox {
      .title {
        font-size: 200%;
      }

      img {
        width: 50px;
      }
    }
    .content {
      .gridbox {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      }
    }
  }
}

@media (max-width: 450px) {
  .wrapper {
      justify-content: space-around;

    .flexbox {
      .title {
        font-size: 150%;
      }
      img {
        width: 50px;
      }
    }
  
  }
}
</style>